import React from "react"

import styles from "./index.module.scss"
import DownArrow from "../../../../../assets/icons/DownArrow"

const Input = React.forwardRef(
  ({ className, value, onChange, disabled, ...props }, ref) => {
    const decrementValue = () => {
      if (props.min && value - 1 < props.min) return
      onChange({ target: { value: value - 1 } })
    }
    const incrementValue = () => {
      if (props.max && value + 1 > props.max) return
      onChange({ target: { value: value + 1 } })
    }

    return (
      <div
        className={`${styles.decimals}`}
        // style={{
        //   width: "100%",
        // }}
      >
        <input
          type="number"
          ref={ref}
          className={`${styles.input} ${className ? className : ""} inputDecimals`}
          value={value}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        {!disabled && (
          <div
            className={styles.arrowsInputContainer}
            disabled={disabled}
            style={{ pointerEvents: disabled ? "none" : "auto" }}
          >
            <DownArrow
              fill={"#6CB6E3"}
              style={{ transform: "rotate(180deg)" }}
              onClick={() => incrementValue()}
            />
            <DownArrow fill={"#6CB6E3"} onClick={() => decrementValue()} />
          </div>
        )}
      </div>
    )
  },
)

Input.displayName = "Input"

export default Input
